import type { ReactNode } from 'react';
import { MotionConfig } from 'motion/react';
import { reducedMotionConfigFor, spring, useMotionMode } from '@/lib/motion';

/** Wraps the app so every Framer Motion component respects the current motion preference. */
export function AppMotionConfig({ children }: { children: ReactNode }) {
  const mode = useMotionMode();
  return (
    <MotionConfig reducedMotion={reducedMotionConfigFor(mode)} transition={spring.soft}>
      {children}
    </MotionConfig>
  );
}
